export const SET_LABELS_LOADING = 'SET_LABELS_LOADING';
export const SET_MISSION_LABELS = 'SET_MISSION_LABELS';
export const CONFIRM_LABEL_SUGGESTION = 'CONFIRM_LABEL_SUGGESTION';
export const SET_MEDIA_TOTAL = 'SET_MEDIA_TOTAL';
export const EMPTY_LABELS_STORE = 'EMPTY_LABELS_STORE';
